import styles from 'sections/aboutUs/howWeCooperate/howWeCooperate.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { OptimizedImg } from 'components/optimizedImg/OptimizedImg';
import { AnimatedImg } from 'components/animatedImg/AnimatedImg';
import { picsUrls } from 'sections/aboutUs/howWeCooperate/howWeCooperate.util';
import { LogoBlackOriginal } from 'components/vectors/LogoBlackOriginal';

export const HowWeCooperate = () => {
    const { t } = useTranslation();

    return (
        <section
            id="section-about-us-how-we-cooperate"
            className={`${generalStyles.heightAuto} ${styles.howWeCooperateSection}`}
        >
            <Element name="howWeCooperate">
                <div className={generalStyles.container}>
                    <div className={styles.howWeCooperate}>
                        <div className={styles.howWeCooperate__pics}>
                            {picsUrls.map(({ desktopSrc, mobileSrc, id }) => {
                                return (
                                    <div key={id}>
                                        <div
                                            className={
                                                styles.howWeCooperate__pic
                                            }
                                        >
                                            <AnimatedImg>
                                                <OptimizedImg
                                                    desktopSrc={desktopSrc}
                                                    mobileSrc={mobileSrc}
                                                />
                                            </AnimatedImg>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className={styles.howWeCooperate__info}>
                            <div className={styles.howWeCooperate__infoLogo}>
                                <LogoBlackOriginal />
                            </div>
                            <p>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                {t('aboutUs.lesFemmesShowWasBornOn')}
                            </p>
                            <p>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                {t('aboutUs.wePerformWearing')}
                            </p>
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
